import { Typography } from '@mui/material';
import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';
import EvolutionIcon from './EvolutionIcon';

type Props = ICellRendererParams & { exercice: number };

// for a given cell, we will get the value associated to the same field but for the previous year
// so that we can compare both values
const getLastYearValue = (params: Props): number | undefined => {
    const lastYearField = params.colDef?.field?.replace(
        String(params.exercice),
        String(params.exercice - 1),
    );
    if (!lastYearField) return undefined;

    // if the cell is aggregated, we will get the aggregated value for the previous year
    const isAggregated = 'aggData' in params.node;
    const lastYearValue = isAggregated
        ? params.node.aggData[lastYearField]
        : params.data[lastYearField];
    return lastYearValue;
};

const getFormattedValue = (
    params: ICellRendererParams,
    value: number,
): string =>
    params?.colDef?.valueFormatter &&
    params.column &&
    typeof params.colDef.valueFormatter === 'function'
        ? params?.colDef?.valueFormatter({
              ...params,
              column: params.column,
              colDef: params.colDef,
              value,
          })
        : value?.toLocaleString();

const LastYearComparatorNumberCellRenderer = (
    params: Props,
): React.ReactElement => {
    const formattedValue =
        params.valueFormatted || getFormattedValue(params, params.value || 0);
    const lastYearValue = getLastYearValue(params);
    const formattedLastYearValue = getFormattedValue(
        params,
        lastYearValue || 0,
    );
    return (
        <>
            <EvolutionIcon
                value={params.value}
                lastYearValue={lastYearValue}
                lastYear={params.exercice - 1}
                formattedLastYearValue={formattedLastYearValue}
            />
            <Typography
                sx={{
                    fontSize: '11px',
                    marginLeft: '0.5rem',
                }}
            >
                {formattedValue}
            </Typography>
        </>
    );
};

export default LastYearComparatorNumberCellRenderer;
